
$('.js-three-slider-arrow').slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [{
        breakpoint: 480,
        settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false
        }
    }]
});

/* For Find Your Style */
$('.js-three-slider-dots').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [{
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            dots: true
        }
    }]
});

/* For Find Your Style */
$('.js-four-slider-arrow').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [{
        breakpoint: 480,
        settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            dots: false
        }
    }]
});
/* For Find Your Style */
$('.js-six-slider-arrow').slick({
    slidesToShow: 6.2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4.2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2.2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                arrows: false,
                dots: false
            }
        }]
});

/* Todays Promo */
let activeSlideSelector = '.slick-slide.slick-current.slick-active';
let todaysPromoTitleSelector = '.full-screen-main-slider .wrapper-slider-image-title-absolute';
let leftSlideSelector = '.todays-promo-slide-grid > .todays-promo-left-slider-title';
let imageWrapperSelector = `${leftSlideSelector} .wrapper-slider-image-title`;
function activateTodaysPromoImageTitleCursor () {
    $(`${todaysPromoTitleSelector}`).css('cursor', 'default');
    $(`${activeSlideSelector} ${imageWrapperSelector} img`).each((index, element) => {
        if ($(element).css('display') !== 'none' && $(element).data('url')) {
            $(`${todaysPromoTitleSelector}`).css('cursor', 'pointer');
        }
    });
}

let progressBarSelector = '.js-slider-todays-promo > .slick-dots';
let changeSlideButtonSelector = '.js-slider-todays-promo > .slick-arrow';
let rightSlideSelector = '.todays-promo-slide-grid > .todays-promo-right-slider-title';
let shadowBoxSelector = '.slider-todays-promo-absolute-title .wrapper-slider-image-title-absolute .wrapper-title-box-shadow';
let productsGridSelector = `${activeSlideSelector} ${rightSlideSelector} .todays-promo-grid-style`;
let progressBarTopInitial;
let changeSlideButtonTopInitial;
let shadowBoxTopInitial = $(`${shadowBoxSelector}`).css('top');
let imageWrapperTopInitial = $(`${imageWrapperSelector}`).css('top');
function resetSlider () {
    $(window).scrollTop(0);
    $(`${progressBarSelector}`).css('top', `${progressBarTopInitial}`);
    $(`${changeSlideButtonSelector}`).css('top', `${changeSlideButtonTopInitial}`);
    $(`${shadowBoxSelector}`).css('top', `${shadowBoxTopInitial}`);
    $(`${imageWrapperSelector}`).css('top', `${imageWrapperTopInitial}`);
}
function moveLeftSlideImage () {
    let progressBarTopOffset = parseInt(progressBarTopInitial) + $(window).scrollTop();
    $(`${progressBarSelector}`).css('top', `${progressBarTopOffset}px`);
    let shadowBoxTopOffset = parseInt(shadowBoxTopInitial) + $(window).scrollTop();
    $(`${shadowBoxSelector}`).css('top', `${shadowBoxTopOffset}px`);
    let imageWrapperTopOffset = parseInt(imageWrapperTopInitial) + $(window).scrollTop();
    $(`${imageWrapperSelector}`).css('top', `${imageWrapperTopOffset}px`);
}
function moveSliderNavigationButtons () {
    let changeSlideButtonTopOffset = parseInt(changeSlideButtonTopInitial) + $(window).scrollTop();
    $(`${changeSlideButtonSelector}`).css('top', `${changeSlideButtonTopOffset}px`);
}
let previousScroll = 0;
function applyStickyBehaviorForSlider () {
    let currentScroll = $(window).scrollTop();
    if (Foundation.MediaQuery.is('medium') && $(`${productsGridSelector}`).length > 0 && $(window).scrollTop() > 0 && $(window).scrollTop() < parseInt($(`${productsGridSelector}`).css('height'))) {
        let activeSlideProductsGridHeight = $(`${activeSlideSelector} ${rightSlideSelector}`).height();
        let activeSlideImageWrapperTop = parseInt($(`${activeSlideSelector} ${imageWrapperSelector}`).css('top'));
        let activeSlideImageWrapperHeight = $(`${activeSlideSelector} ${imageWrapperSelector}`).height();
        let imageIsInsideTheContainer = activeSlideProductsGridHeight - activeSlideImageWrapperTop >= activeSlideImageWrapperHeight;
        if (imageIsInsideTheContainer) {
            moveLeftSlideImage();
            moveSliderNavigationButtons();
        } else {
            imageIsInsideTheContainer = activeSlideProductsGridHeight - (parseInt(imageWrapperTopInitial) + currentScroll) >= activeSlideImageWrapperHeight;
            if (currentScroll <= previousScroll && imageIsInsideTheContainer) {
                moveLeftSlideImage();
                moveSliderNavigationButtons();
            }
        }
    }
    if (Foundation.MediaQuery.is('small only')) {
        moveSliderNavigationButtons();
    }
    previousScroll = currentScroll;
}

$('.js-slider-todays-promo').on('beforeChange', () => {
    resetSlider();
});

$('.js-slider-todays-promo').on('afterChange change', () => {
    activateTodaysPromoImageTitleCursor();
    $(window).off('scroll', applyStickyBehaviorForSlider);
    $(window).on('scroll', applyStickyBehaviorForSlider);
});

function hideChatBot () {
    let config = { attributes: false, childList: true, subtree: false };
    let callback = function (mutationsList, observer) {
        if (Foundation.MediaQuery.is('small only') && $('button#esw-fab').length > 0) {
            $('button#esw-fab').css('display', 'none');
            observer.disconnect();
        }
    };
    let observer = new MutationObserver(callback);
    observer.observe($('body').get(0), config);
}

$('.js-slider-todays-promo').on('init', () => {
    hideChatBot();
});

$('.js-slider-todays-promo').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 6500,
    adaptiveHeight: true,
    slide: '.experience-component',
    responsive: [{
        breakpoint: 300,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        }
    }]
});

let pagePaddingTop = $('.page.page-hero').css('padding-top');
function updateTodaysPromoButtons () {
    $('.todays-promo-slide-grid').each((index, element) => {
        if ($(element).find('.todays-promo-grid-style').length === 0) $(element).children('.js-todays-promo-button-products').remove();
        else $(element).children('.js-todays-promo-button-copy').remove();
        $(element).children('button').on('click', () => {
            let rightSlideTop = $(`${rightSlideSelector}`).offset().top;
            let scrollTop = rightSlideTop - parseInt(pagePaddingTop);
            $('html, body').animate({
                scrollTop: scrollTop.toString() + 'px'
            }, 750);
        });
    });
}
function hideTodaysPromoRightSlideFromTheViewport () {
    let buttonTotalHeight = $('.js-todays-promo-button-copy').outerHeight();
    let imageHeightDecrease = parseInt($('.page.page-hero').css('padding-top')) + buttonTotalHeight;
    let imageHeight = $(window).height() - imageHeightDecrease;
    $(`${imageWrapperSelector} img`).css('height', `${imageHeight}px`);
}

function activateTodaysPromoImagesLinkAndCursor () {
    $(`${imageWrapperSelector} img`).each((index, element) => {
        if ($(element).data('url')) {
            $(element).parents(`${leftSlideSelector} > div`).css('cursor', 'pointer');
            $(element).on('click', () => {
                window.location = $(element).data('url');
            });
        }
    });
    $(`${todaysPromoTitleSelector}`).on('click', () => {
        $(`${activeSlideSelector} ${leftSlideSelector} .wrapper-slider-image-title img`).each((index, element) => {
            if ($(element).css('display') !== 'none' && $(element).data('url')) {
                window.location = $(element).data('url');
            }
        });
    });
    activateTodaysPromoImageTitleCursor();
    $('.todays-promo-slide-grid .wrapper-caption-center, .todays-promo-slide-grid .wrapper-title-bottom').on('click', (event) => {
        $(event.target).siblings('img').each((index, element) => {
            if ($(element).data('url')) {
                window.location = $(element).data('url');
            }
        });
    });
    $('.todays-promo-slide-grid .wrapper-title-bottom .cnt-sales-title, .todays-promo-slide-grid .wrapper-title-bottom .cnt-sales-legal').on('click', (event) => {
        $(event.target).parent().siblings('img').each((index, element) => {
            if ($(element).data('url')) {
                window.location = $(element).data('url');
            }
        });
    });
}
function updateTodaysPromoImages () {
    if (Foundation.MediaQuery.is('small only')) {
        hideTodaysPromoRightSlideFromTheViewport();
    }
    activateTodaysPromoImagesLinkAndCursor();
}
function updateTodaysPromoTitleAndProgressBar () {
    if (Foundation.MediaQuery.is('small only')) {
        let left = $('div.page > header > nav > div').css('padding-left');
        let width = $('div.page > header > nav > div').width();
        $(`${shadowBoxSelector} h1`).css('left', left);
        $(`${progressBarSelector}`).css('left', left);
        $(`${progressBarSelector}`).css('width', `${width}px`);
    }
    if (Foundation.MediaQuery.is('medium only')) {
        let leftSlideMarginLeft = $(`${leftSlideSelector}`).css('margin-left');
        $(`${shadowBoxSelector}`).css('width', `calc(50vw - ${leftSlideMarginLeft})`);
    }
}
function updateTodaysPromoSlider () {
    progressBarTopInitial = $(`${progressBarSelector}`).css('top');
    changeSlideButtonTopInitial = $(`${changeSlideButtonSelector}`).css('top');
    $(window).on('scroll', applyStickyBehaviorForSlider);
    updateTodaysPromoButtons();
    updateTodaysPromoImages();
    updateTodaysPromoTitleAndProgressBar();
}
updateTodaysPromoSlider();

$('.js-button-scroll').on('click', function () {
    var smooth = [$('a.smooth'), 100, 750];
    $('html, body').animate({
        scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top - smooth[1]
    }, smooth[2]);
    return false;
});

$('.js-quizImages').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    infinite: false,
    responsive: [{
        breakpoint: 480,
        settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dot: true
        }
    }]
});

// CAROUSEL HOMEPAGE
$('.js-hp-hero-banner-title-cta').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    responsive: [{
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
        }
    }]
});

let lastSlideCover = 0;
let slideCountCover = 0;
let optionsCover = {};
var sliderBlockedForScrolling = false;
var sliderBlockedTimeout = null;

if ($(window).width() > 1024) {
    optionsCover = {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        draggable: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800
    };
} else {
    optionsCover = {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: true,
        draggable: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800
    };
}

function onSliderWheel (e) {
    var deltaY = e.originalEvent.deltaY;
    var $currentSlider = $(e.currentTarget);
    var currentSlickIndex = $currentSlider.data('current-slide') || 0;

    if (
        ((deltaY < 0 && currentSlickIndex === 0) || window.pageYOffset > 0) ||
        ((deltaY > 0 && currentSlickIndex === $currentSlider.data('slider-length') - 1) || window.pageYOffset > 0)
    ) { return; }

    e.preventDefault();
    clearTimeout(sliderBlockedTimeout);
    sliderBlockedTimeout = setTimeout(function () {
        sliderBlockedForScrolling = false;
    }, 50);

    if (!sliderBlockedForScrolling) {
        sliderBlockedForScrolling = true;
        if (e.originalEvent.deltaY < 0) {
            $currentSlider.slick('slickPrev');
        } else {
            $currentSlider.slick('slickNext');
        }
    }
}

function magnetiSliderHandler () {
    var blue = document.querySelector('.js-hp-magnetic-hero-banner-title-cta');
    var hammer = new Hammer.Manager(blue);
    var swipe = new Hammer.Swipe();

    hammer.add(swipe);

    var red = blue.parentNode;
    var hammerRed = new Hammer.Manager(red);
    var swipeRed = new Hammer.Swipe();

    hammerRed.on('swipeup', function () {
        hammer.remove(swipe);
        hammerRed.remove(swipeRed);
    });

    hammerRed.on('swipedown', function () {
        $('.js-hp-magnetic-hero-banner-title-cta').slick('slickPrev');
        hammer.add(swipe);
        hammerRed.remove(swipeRed);
    });

    hammer.on('swipeup', function () {
        $('.js-hp-magnetic-hero-banner-title-cta').slick('slickNext');
        setTimeout(() => {
            if (lastSlideCover) {
                hammer.remove(swipe);
                hammerRed.add(swipeRed);
            }
        }, 800);
    });

    hammer.on('swipedown', function () {
        $('.js-hp-magnetic-hero-banner-title-cta').slick('slickPrev');
    });

    $(window).on('scroll', () => {
        if ($(window).scrollTop() === 0) {
            hammer.add(swipe);
        }
    });
}

$(document).ready(function () {
    $('.js-hp-magnetic-hero-banner-title-cta').on('init', (event, slick) => {
       $('.slider-center-content').removeClass("d-none");

        if (slideCountCover === 0) slideCountCover = slick.slideCount;
        if (slideCountCover > 1) {
            magnetiSliderHandler();
        }
    });
    $('.category-top-banner').find('.close-button').click(function (e) {

        let pixelsToAdd = $('.category-top-banner').height();
        let newSliderHeight = $('.js-hp-magnetic-hero-banner-title-cta').height() + pixelsToAdd;
        $('.js-hp-magnetic-hero-banner-title-cta').animate({ height: newSliderHeight + 'px' }, 400);
        $('.js-hp-magnetic-hero-banner-title-cta').find('.slick-list').animate({ height: newSliderHeight + 'px' }, 400);
        $('.js-hp-magnetic-hero-banner-title-cta').find('.slick-track').animate({ height: newSliderHeight + 'px' }, 400);
    });

    // CAROUSEL HOMEPAGE
    let slider = $('.js-hp-magnetic-hero-banner-title-cta');
    function onSliderAfterChange (event, slick, currentSlide) {
        $(event.target).data('current-slide', currentSlide);

        if (slideCountCover > 1) {
            if (slick.$slides.length - 1 == currentSlide) {
                lastSlideCover = !lastSlideCover;
            } else {
                lastSlideCover = 0;
            }
        }
    }

    let showArrows = true;
    try {
        let magneticSliderSlidesCount = document.querySelector('.js-hp-magnetic-hero-banner-title-cta').querySelectorAll('.slider-content-wrapper').length;
        if (magneticSliderSlidesCount === 1) {
            showArrows = false;
        }
    } catch (e) {
        showArrows = true;
    }
    optionsCover.dots = showArrows;

    slider.each(function (index, element) {
        var $element = $(element);
        $element.data('slider-length', $element.children().length);
    })
        .slick(optionsCover)
        .on('afterChange', onSliderAfterChange)
        .on('wheel', onSliderWheel);

    $(window).resize(function () {
        if (slider && slider.length) {
            slider[0].slick.refresh();
        }
    });
});

$('.js-hp-four-slider').slick({
    slidesToShow: 5.3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    responsive: [

        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2.2,
                slidesToScroll: 2,
                autoplay: false,
                infinite: false,
                autoplaySpeed: 2000,
                arrows: false,
                dots: false
            }
        }]
});
